<template>
  <sqr-modal @close="$emit('close')">
    <h1 class="text-lg font-semibold text-gray-700 mb-3">
      {{ $t('position_select_modal_title') }}
    </h1>
    <div class="help is-danger" v-if="validation">
      {{ $t('validation_general') }}
    </div>
    <sqr-progress color="primary" v-show="loading" />
    <sqr-input-text
      class="mb-3"
      :placeholder="$t('position_select_modal_filter')"
      v-model="query"
      ref="search"
      v-on:keyup.enter="selectFirst()"
      v-on:keyup.esc="$emit('close')"
    />
    <div style="max-height: 80vh;" class="overflow-y-scroll h-full relative">
      <template v-for="category in categories">
        <div
          class="font-bold text-gray-700 sticky top-0 bg-white border-b truncate"
          :key="category.id"
          v-if="filteredPositionsByCategoryId[category.id]"
        >
          <!-- {{ category.id }} -->
          {{ category.label18[lang] }}
        </div>
        <ul
          :key="`${category.id}-ul`"
          class="pb-3"
          v-if="
            filteredPositionsByCategoryId[category.id] &&
              filteredPositionsByCategoryId[category.id].length > 0
          "
        >
          <li
            class="py-2 truncate hover:bg-blue-50 cursor-pointer"
            :class="{ 'border-t': index > 0 }"
            v-for="(position, index) in filteredPositionsByCategoryId[
              category.id
            ]"
            :key="category.id + '-' + position.id"
          >
            <a @click="select(position)">
              <span class="font-bold">{{ position.code }}</span>
              {{ position.label }}
            </a>
          </li>
        </ul>
      </template>
    </div>
  </sqr-modal>
</template>

<script>
import { mapGetters } from 'vuex';

import SqrModal from '@/components/SqrModal';
import SqrProgress from '@/components/SqrProgress';
import SqrInputText from '@/components/SqrInputText';

import catalog from '@/data/catalog';

export default {
  name: 'PatientSelectModal',
  components: {
    SqrModal,
    SqrProgress,
    SqrInputText
  },
  props: {
    date: {
      type: String,
      default: () => new Date().toISOString().substring(0, 10)
    },
    invoiceId: { type: String },
    validation: { type: Boolean }
  },
  computed: {
    ...mapGetters('patients', { patients: 'records', loading: 'loading' }),
    lang() {
      return this.$i18n.locale;
    },
    categories() {
      return catalog.categories;
    },
    // positions() {
    //   return catalog.positions.map(p => ({
    //     id: p.id,
    //     tarif: p.tarif,
    //     label: [p.id, p.label.fr].join(' '),
    //     label18: p.label
    //   }));
    // },
    positionsByCategoryId() {
      const lang = this.lang;
      const today = this.date;
      const mapPos = position => ({
        id: position.id,
        tarif: position.tarif,
        label: [position.id, position.label[lang]].join(' '),
        label18: position.label
      });

      const availablePositions = catalog.positions.filter(
        pos =>
          today.localeCompare(pos.validFrom) >= 0 &&
          today.localeCompare(pos.validTo) <= 0
      );

      const entries = catalog.categories.map(category => {
        return [
          category.id,
          availablePositions
            .filter(position => position.category === category.id)
            .map(mapPos)
        ];
      });

      return Object.fromEntries(entries);
    },
    filteredPositionsByCategoryId() {
      const query = this.query.toLowerCase();
      // if there is no query return the full positionsByCategoryId
      if (!query) return this.positionsByCategoryId;
      // filter by label
      const filtered = Object.entries(
        this.positionsByCategoryId
      ).map(([id, positions]) => [
        id,
        positions.filter(pos => pos.label.toLowerCase().indexOf(query) >= 0)
      ]);
      // remove the category with no matching positions
      const pruned = filtered.filter(([, positions]) => positions.length > 0);
      // transform back from [key, value] to {[key]: value}
      return Object.fromEntries(pruned);
    }
  },
  data() {
    return {
      query: ''
    };
  },
  mounted() {
    this.$refs.search.$el.querySelector('input').focus();
  },
  methods: {
    select(position) {
      this.$emit('selected', position);
    },
    selectFirst() {
      const entries = Object.entries(this.filteredPositionsByCategoryId);
      if (entries.length > 0) {
        const pair = entries[0];
        const positions = pair[1];
        if (positions.length > 0) {
          this.select(positions[0]);
        }
      }
    },
    cancel() {
      this.$emit('close');
    }
  }
};
</script>
